<template>
<div>
  <DetailListItem
    :title="title"
    :figureIndex="right"
    :secondFigureIndex="left"
    :thirdFigureIndex="judge"/>
</div>
</template>

<script>
import DetailListItem from './DetailListItem.vue'

import names from '../utils/names'

export default {
  name: 'Triplicity',
  components: {
    DetailListItem,
  },
  props: {
    title: String,
    left: Number,
    right: Number,
    judge: Number,
  },
  computed: {
    getTriplicityLabel() {
      return names.getNameForFigure(this.$store.getters.getFigureById(this.right))
    }
  }
}
</script>

<style lang="scss" scoped>
.legend {
  margin: 12px 0 8px;
  border-bottom: 1px solid black;
}
</style>
